<template>
  <div class="body">
    <top-message></top-message>
    <div class="main">
      <div class="header">
        业务上报历史
      </div>
      <el-form
        :inline="true"
        style="margin:20px 30px;"
      >
        <el-form-item label="上报年份">
          <el-date-picker
            v-model="form.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
            @change="headerYear()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上报月份">
          <el-date-picker
            style="width:140px;"
            v-model="form.month"
            type="month"
            format="M 月"
            value-format="MM"
            placeholder="选择月"
            :editable="false"
            popper-class="myMonth"
            @change="headerYear()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报表类型">
          <el-select
            style="width:140px;"
            v-model="form.fileType"
            clearable
            @change="headerYear()"
            placeholder="请选择"
          >
            <el-option
              v-for="item in rongziList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上报状态">
          <el-select
            v-model="form.result"
            clearable
            placeholder="请选择"
            style="width:102px;"
            @change="headerYear()"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          prop="createYear"
          label="所属年份"
        >
        </el-table-column>
        <el-table-column
          prop="createMonth"
          label="所属月份"
        >
        </el-table-column>
        <el-table-column
          prop="fileType"
          label="报表类型"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="result"
          label="上报状态"
        >
        </el-table-column>
        <el-table-column
          prop="created"
          label="上报人"
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="createHour"
          label="上报时间"
        >
        </el-table-column>

        <el-table-column
          label="操作"
          prop="operation"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.result=='成功'"
              style="color: #2981EE;cursor: pointer;"
              @click="xiazai(scope.row)"
            >下载</span>
            <span
              v-if="scope.row.result=='失败'"
              style="color: #2981EE;cursor: pointer;"
              @click="view(scope.row)"
            >查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="680px"
      :close-on-click-modal="false"
      class="my-info-dialog"
      :show-close="false"
      :close-on-press-escape="false"
      :destroy-on-close='true'
    >
      <div class="dlgheader">
        <div class="toptitle">本地区信易贷成效报送</div>
        <div class="template">
          <div class="financing">
            <img
              src="../../assets/images/excel.png"
              alt=""
            >
            信易贷融资成效报表模板
            <el-link
              type="primary"
              style="margin-left:8px;"
              @click="getreportStatisticsTemplate()"
            >下载</el-link>
          </div>
          <div class="financing">
            <img
              src="../../assets/images/excel.png"
              alt=""
            >
            信易贷注册企业报表模板
            <el-link
              @click="getReport"
              type="primary"
              style="margin-left:8px;"
            >下载</el-link>
          </div>
        </div>
        <div class="type">
          <div class="top">
            <span class="a">*</span>
            <span class="b ">上传报表类型</span>
            <el-select
              style="width:290px;margin-left:8px;"
              v-model="params.type"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in rongziList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="middle">
            <span class="c">请点击上传
              <el-upload
                class="upload-demo"
                :action="xslUrl"
                :headers="headers"
                :data='params'
                accept=".xlsx,.xls"
                :show-file-list='false'
                :on-success='handleAvatarSuccess'
                :auto-upload="false"
                ref="upload"
                :on-change='handName'
                :modal='false'
              >
                <el-link
                  type="primary"
                  style="font-size:20px;margin-left:5px;"
                >选择文件</el-link>
              </el-upload>
            </span>
            <div class="d">
              <span class="a">*</span>
              <span class="b ">仅支持上传xls/xlsx文件</span>
            </div>
          </div>
          <div class="btn">
            <img
              src="../../assets/images/excel.png"
              alt=""
            >
            {{ this.Name }}
          </div>
        </div>
        <div class="button">
          <el-button
            class="cancel"
            @click="cancel"
          >取消</el-button>
          <el-button
            class="midden"
            @click="cancel"
          >查看记录</el-button>
          <el-button
            class="last"
            @click="handleUpload"
          >上传</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 失败 -->
    <el-dialog
      :visible.sync="errorStatus"
      width="544px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      class="error"
    >
      <div style="display:flex;flex-direction:column;align-items:center;">
        <img
          src="../../assets/images/warning.png"
          style="width:54px;height:48px;"
        >
        <div style="margin-top:19px;font-size: 26px;
font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #000000;">上传失败</div>
        <div style="margin-top:22px;font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #000000;">{{this.msg}}</div>
        <div style="margin-top:40px;">
          <el-button
            @click="original"
            v-if="this.msg !=='导入成效统计报表失败'||this.msg !=='导入企业明细表失败'"
            style="width: 168px;
height: 44px;
background: #DDECFF;
border: 1px solid #2981EE;
border-radius: 8px;font-size: 20px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #2981EE;"
          >下载原表格</el-button>
          <el-button
            style="width: 162px;
height: 44px;
background: #2981EE;
border: 1px solid #2981EE;
border-radius: 8px;font-size: 20px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;"
            @click="again"
          >重新上传</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="successStatus"
      width="30%"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :show-close="false"
    >
      <div style="display:flex;flex-direction:column;align-items:center;">
        <img
          src="../../assets/images/success.png"
          alt=""
        >
        <div style="font-size: 26px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #000000;margin-top:20px;">上传成功</div>
        <el-button
          style="margin-top:26px;width: 108px;
height: 44px;
background: #2981EE;
border: 1px solid #2981EE;
border-radius: 8px;font-size: 20px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #FFFFFF;"
          @click="enter"
        >确认</el-button>
      </div>
    </el-dialog>
    <!-- 等待中 -->
    <el-dialog
      :visible.sync="loadingStatus"
      width="470px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div class="loading">
        <div
          class="top"
          v-loading="loading"
        ></div>
        <div style="margin-top:17px;font-size: 26px;
font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #000000;">核验中</div>
        <div style="margin-top:22px;font-size: 18px;
font-family: Alibaba PuHuiTi;
font-weight: 400;">上传数据较多，请等待系统核验</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TopMessage from '../TopMessage.vue'
import { execute } from '@/api/statistics'
export default {
  components: {
    TopMessage
  },
  data () {
    return {
      form: {
        year: '',
        month: '',
        fileType: '',
        result: ''
      },
      tableData: [],
      xslUrl: this.baseUrl + '/api/credit/import/importStaticsData',
      headers: {
        token: sessionStorage.getItem('token')
      },
      params: {
        type: null,
        id: ''
      },
      Name: '',
      rongziList: [
        { value: 8, label: '信易贷融资成效报表' },
        { value: 9, label: '信易贷注册企业报表' },
      ],
      statusList: [
        { value: 8, label: '成功' },
        { value: 9, label: '失败' },
      ],
      dialogVisible: false,
      errorStatus: false,
      successStatus: false,
      msg: '',
      loadingStatus: false,
      loading: true,
      status: '',
      id: '',
      fileType: '',
      fileId: ''
    }
  },
  created () {
    this.getExecute()
    this.status = sessionStorage.getItem("status")
    if (this.status == 1) {
      this.dialogVisible = true
    }
  },
  methods: {
    getReport () {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/downloadCompanyInfo", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷注册企业报表模板.xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    },
    xiazai (e) {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/downloadFile" + '?id=' + e.fileId, true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = e.fileType + ".xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    },
    view (row) {
      this.id = row.id
      this.fileType = row.fileType
      this.msg = row.reason
      this.errorStatus = true
      this.fileId = row.fileId
      console.log(this.fileId);
      if (row.fileType == '信易贷融资成效报表') {
        this.params.type = 8
      } else if (row.fileType == "信易贷注册企业报表") {
        this.params.type = 9
      }

    },
    original () {
      let typeid = this.fileType
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/downloadFile" + '?id=' + this.fileId, true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = typeid + ".xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    },
    headerYear () {
      this.getExecute()
    },
    getExecute () {
      execute(this.sendParam(this.form)).then(res => {
        res = this.paramDecrypt(res)
        console.log(res)
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch(err => { })
    },
    enter () {
      this.successStatus = false
      this.getExecute()

    },
    again () {
      this.errorStatus = false,
        this.dialogVisible = true,
        this.params.id = this.id
    },
    handName (res, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.Name = res.name
    },
    handleAvatarSuccess (res) {
      setTimeout(() => {
        if (!res) {
          this.loadingStatus = true
          sessionStorage.removeItem("status")
        }
      }, 3000);
      if (res.code == 200) {
        this.successStatus = true
        this.dialogVisible = false
        this.Name = ''
        this.params.type = null
        sessionStorage.removeItem("status")
      } else if (res.code == 202) {
        this.errorStatus = true
        this.dialogVisible = false
        sessionStorage.removeItem("status")
        this.Name = ''
        this.params.type = null
        this.msg = res.msg
        this.fileId = res.data.fileId
        this.fileType = res.data.fileType
      }
    },
    handleUpload () {
      if (this.params.type !== null && this.Name !== '') {
        this.$refs.upload.submit();
      } else if (this.params.type == null) {
        this.$message.error('请选择报表类型')
      } else if (this.Name == '') {
        this.$message.error('请上传文件')
      }
    },
    getreportStatisticsTemplate () {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/downloadReportStatistics", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷融资成效报表模板.xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send();
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.result === '失败') {
        return 'warning-row';
      } else if (row.result === '成功') {
        return 'success-row';
      }
      return '';
    },
    cancel () {
      this.dialogVisible = false;
      sessionStorage.removeItem("status")
    }
  }
}
</script>
<style >
.my-info-dialog .el-dialog__body {
  background-color: #f2f2f2;
}
.my-info-dialog .el-dialog__header {
  display: none;
}
.el-table .warning-row {
  background: #fff9f8;
}

.el-table .success-row {
  background: #fff;
}
</style>
<style lang='less' scoped>
.body {
  width: 100%;
  min-height: 800px;

  .main {
    width: 100%;
    min-height: 800px;
    background-color: #fff;
    margin-top: 15px;
    border-radius: 4px;
    padding-top: 27px;

    .header {
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2981ee;
      border-left: 8px solid #2981ee;
      padding-left: 27px;
    }
    /deep/ .el-table th > .cell {
      text-align: center;
      color: #252525;
    }
    /deep/ .el-table th.is-leaf {
      border: none;
      background: #f3f4f9;
    }
    /deep/ .el-table td {
      border: none;
    }
    /deep/ .el-table .cell {
      text-align: center;
    }
  }
  .dlgheader {
    width: 100%;
    background-color: #f2f2f2;

    .toptitle {
      font-size: 26px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #000000;
      text-align: center;
    }
    .template {
      width: 588px;
      height: 136px;
      background: #d9ece1;
      border-radius: 2px;
      margin-left: 25px;
      margin-top: 28px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-evenly;
      .financing {
        display: flex;
        align-items: center;
        img {
          margin-right: 8px;
        }
      }
    }
    .type {
      width: 588px;
      height: 280px;
      background: #ffffff;
      border: 1px solid #d4d4d7;
      border-radius: 2px;
      margin-left: 25px;
      margin-top: 21px;
      box-sizing: border-box;
      padding: 28px 38px;
      .top {
        width: 100%;
        height: 65px;
        border-bottom: 1px solid #dedee0;
        display: flex;
        .a {
          font-size: 24px;
          font-family: Alibaba PuHuiTi;
          font-weight: 600;
          color: #f85b4b;
          margin-top: 8px;
          margin-left: 37px;
        }
        .b {
          font-size: 18px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          margin-top: 8px;
        }
      }
      .middle {
        height: 114px;
        width: 100%;
        border-bottom: 1px solid #dedee0;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;
        .c {
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          display: flex;
        }
        .d {
          display: flex;
          .a {
            font-size: 24px;
            font-family: Alibaba PuHuiTi;
            font-weight: 600;
            color: #f85b4b;
          }
          .b {
            font-size: 18px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #a2a4ac;
            margin-left: 5px;
          }
        }
      }
      .btn {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .button {
      width: 100%;
      margin-top: 34px;
      display: flex;
      justify-content: space-evenly;
      .cancel {
        width: 140px;
        height: 44px;
        background: #f3f4f9;
        border: 1px solid #a2a4ac;
        border-radius: 8px;
      }
      .midden {
        width: 140px;
        height: 44px;
        background: #ddecff;
        border: 1px solid #2981ee;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2981ee;
        line-height: 18px;
      }
      .last {
        width: 140px;
        height: 44px;
        background: #2981ee;
        border: 1px solid #2981ee;
        border-radius: 8px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .loading {
    display: flex;
    align-items: center;
    flex-direction: column;
    .top {
      width: 54px;
      height: 56px;
    }
  }
}
</style> 
<style lang="less">
.myMonth {
  .el-date-picker__header {
    display: none;
  }
}
</style>
